import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ItemNavegacaoModuloGerencial, ModuloGerencial } from '../core/rotas/navegacao-menu-gerencial';
import { AlertaMensagemComponent } from '../shared/alerta-mensagem.component';
import { CabecalhoMarcaComponent } from '../shared/cabecalho-marca.component';
import { NavegacaoServidorComponent } from '../shared/navegacao-servidor.component';

@Component({
  selector: 'app-layout-modulo-gerencial',
  standalone: true,
  imports: [CommonModule, CabecalhoMarcaComponent, AlertaMensagemComponent, NavegacaoServidorComponent],
  templateUrl: './layout-modulo-gerencial.component.html'
})
export class LayoutModuloGerencialComponent {
  @Input() logo = '';
  @Input() iniciais = '';
  @Input() nome = '';
  @Input() agora = new Date();
  @Input() aba: ModuloGerencial = 'menu';
  @Input() itens: ItemNavegacaoModuloGerencial[] = [];
  @Input() mensagem = '';

  @Output() selecionar = new EventEmitter<string>();
  @Output() sair = new EventEmitter<void>();
}
